import { render, staticRenderFns } from "./EmptyState.global.vue?vue&type=template&id=92945694&functional=true&"
import script from "./EmptyState.global.vue?vue&type=script&lang=js&"
export * from "./EmptyState.global.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  null,
  null
  
)

export default component.exports